import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const columns = [
    {
        dataField: 'PurchaseOrder',
        caption: 'Purchase order',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        fixed: true,
        allowEditing: false,
    },
    {
        dataField: 'ProductIdDisplay',
        caption: 'Product',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        fixed: true
    },
    {
        dataField: 'Quantity',
        caption: 'Quantity',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right'
    },
    {
        dataField: 'BuyPrice',
        caption: 'Buy price',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right'
    },
    {
        dataField: 'Extended',
        caption: 'Extended',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        allowEditing: false,
        alignment: 'right'
    },
    {
        dataField: 'BuyUnit',
        caption: 'Unit',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        allowSorting: false,
        allowEditing: false
    },
    {
        dataField: 'SupplierProduct',
        caption: 'Supplier product',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        format: '#0.00',
        allowSorting: false,
        allowEditing: false
    },
    {
        dataField: 'Description',
        caption: 'Description',
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.lg0,
        allowSorting: false,
        isEditable: true,
    },
    {
        dataField: 'ProductId',
        caption: 'ProductId',
        visible: false
    },
    {
        dataField: 'LineNumber',
        caption: 'LineNumber',
        visible: false
    },
];

export const FieldName = {
    quantity: 'OrderedQuantity',
    product: 'Product',
    price: 'Price',
};

export const FastEntryEnabledStatus = ['Preparing', 'Modifying'] as const;
